<script lang='ts'>
    export let text: string
    export let value: string
</script>

<div class="pt-3 text-center">
    <span class="font-bold">{value ?? '-'}</span>
    <h6 class="my-2 text-sm font-normal">{text}</h6>
</div>